export class ContactUsRequest {
  name: string;
  email: string;
  phoneNumber: string;
  message: string;
}
